import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import moment from "moment";
import queryString from "query-string";
import { Box, Button, Flex, Spinner, Text, Textarea, useColorMode } from "theme-ui";
import { FaLink } from "react-icons/fa";
import { bucketUrl } from './global';
import { linkifyText } from "./textFormat";
import {
    TaskWithId,
    DeletionPermissionResult,
    DeletionItemTask,
    DeletionItemStage,
    DeletionUserRoleInput,
} from "../../@types";
import {
    DeliveryData,
    DescriptionPayload,
    SheetIndexItem,
    TradeItem,
} from "../Components/History/DeliveryHistory.types";


export const generateQueryString = (...keyValuePairs: [any, any][]): any => {
    const queryParams: { [key: string]: string } = {};
    keyValuePairs.forEach(([key, value]) => {
        if (key !== '' && key !== null && key !== undefined && value !== '' && value !== null && value !== undefined) {
            queryParams[key] = value;
        }
    });

    const queryString = Object.keys(queryParams)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
        .join('&');
    return queryString ? "?" + queryString : '';
};
export const generateQueryStringForTable = (...keyValuePairs: [any, any, any][]): any => {
    const queryParams: { [key: string]: string } = {};
    keyValuePairs.forEach(([key, value]) => {
        if (key !== '' && key !== null && key !== undefined && value !== '' && value !== null && value !== undefined) {
            queryParams[key] = value;
        }
    });
    const queryString = Object.keys(queryParams)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
        .join('&');

    return queryString ? "?" + queryString : '';
};
export const removeDuplicateQueryParams = (queryString: string): string => {
    const params = new URLSearchParams(queryString);
    const uniqueParams = new URLSearchParams();
    for (const [key, value] of params) {
        uniqueParams.set(key, value);
    }
    return `?${uniqueParams.toString()}`;
};

export const getApiEndPoint = (
    pagination: {
        currentPage?: number;
        limit?: number;
        userId?: string;
        email?: string;
        read?: boolean;
    },
    searchUrl: string,
    column?: { accessorKey: string, filterType: string, header?: any }[],
    pathname?: string
): string => {
    const parsedQuery = queryString.parse(searchUrl);
    const keyValueArray: Array<[string, string]> = Object.entries(parsedQuery)
        .filter(([key, value]) => key && value !== null && key !== "id" && key !== "isRunning")
        .map(([key, value]) => [key, value as string]);
    let dynemicFilter: { type: string, value: string, key: string, caseSensitive: boolean, startDate?: string, endDate?: string, min?: string, max?: string, startTime?: string, endTime?: string }[] = [];
    keyValueArray.forEach(([key, value]) => {
        let findColumnData = column?.find((val: { accessorKey: string, filterType: string }) => val?.accessorKey === key)
        if (findColumnData) {
            if (findColumnData?.filterType === "date") {
                let date: string[] = value?.split("to");
                const startDate = findColumnData?.accessorKey === "comment_date" ? moment(date[0].trim()).format("MM/DD/YYYY") : date[0].trim();
                const endDate = findColumnData?.accessorKey === "comment_date" ? moment(date[1].trim()).format("MM/DD/YYYY") : date[1].trim();
                dynemicFilter.push({
                    type: "date",
                    value: date.length === 2 ? `${startDate} to ${endDate}` : value.trim(),
                    key: key,
                    caseSensitive: false,
                    startDate: startDate,
                    endDate: endDate
                })
            } else if (findColumnData?.filterType === "estimateBox") {
                let numberData: string[] = value?.split("to");
                dynemicFilter.push({
                    type: key,
                    value: value.trim(),
                    key: key,
                    caseSensitive: false,
                    min: numberData[0],
                    max: numberData[1]
                })
            }
            else if (findColumnData?.filterType === "timeRangeBox") {
                const timeData: string[] = value?.split("to");
                const StartDateTimeISO = timeData[0]?.trim();
                const EndDateTimeISO = timeData[1]?.trim();
                if (StartDateTimeISO && EndDateTimeISO) {
                    dynemicFilter.push({
                        type: "updatedAt",
                        value: `${StartDateTimeISO}to${EndDateTimeISO}`,
                        key: key,
                        caseSensitive: false,
                        startDate: StartDateTimeISO,
                        endDate: EndDateTimeISO,
                    });
                }
            }
            else if (findColumnData?.filterType === "dropdown" && findColumnData?.header?.toLowerCase() === "project name") {
                dynemicFilter.push({
                    type: "string",
                    value: value,
                    key: pathname?.includes('/deliveries') ? "projectId" : (findColumnData?.accessorKey === "projectId" ? "projectId._id" : "_id"),
                    caseSensitive: false
                })
            } else if (findColumnData?.filterType === "dropdown" && (key === "stageId" || (pathname?.includes("manual-deliveries") && (key === "name" || findColumnData?.header?.toLowerCase() === "stage name")))) {
                dynemicFilter.push({
                    type: "string",
                    value: value,
                    key: "stageId",
                    caseSensitive: false
                })
            } else if (key === "publishingReady" || key === "projectManagerDeliver") {
                if (value === "false") {
                    dynemicFilter.push({
                        type: "string",
                        value: "false",
                        key: key,
                        caseSensitive: false
                    });
                    dynemicFilter.push({
                        type: "string",
                        value: "null",
                        key: key,
                        caseSensitive: false
                    });
                } else {
                    dynemicFilter.push({
                        type: "string",
                        value: value,
                        key: key,
                        caseSensitive: false
                    });
                }
            } else if (pathname === '/generalTimer-report' && findColumnData?.filterType === "dropdown") {
                dynemicFilter.push({
                    type: "array",
                    value: value,
                    key: "_id",
                    caseSensitive: false
                })
            }
            else {
                dynemicFilter.push({
                    type: findColumnData?.filterType === "multi-select-dropdown" ? "array" : findColumnData?.filterType === "date" ? "date" : findColumnData?.filterType === "timeRangeBox" ? "timeRangeBox" : findColumnData?.filterType === "number" ? "number" : "string",
                    value: value,
                    key: findColumnData?.filterType === "multi-select-dropdown" ? (key === "highlighters" || key === "Role" || key === "projectWorker" || key === "worker" || key === "salesRepresentative" || key === "manager" || key === "members" || key === "userId" || key === "badgeHistory.badgeCriteria" || key === "badgeHistory.badgeId") ? `${key}` : `${key}._id` : key,
                    caseSensitive: findColumnData?.filterType === "textbox" ? true : false
                })
            }
        }
    })
    if (pathname === '/stages-view-second' || pathname === '/project-view-two') {
        dynemicFilter.push({
            type: "boolean",
            value: "true",
            key: "isNoFilters",
            caseSensitive: false
        });
    }
    if (pathname === '/completed-todos') {
        dynemicFilter.push({
            type: "string",
            value: "true",
            key: "isCompleted",
            caseSensitive: false
        });
    }
    if (pathname === '/todos' || pathname === '/my-todo' || pathname === '/assigned-todo') {
        dynemicFilter.push({
            type: "string",
            value: "false",
            key: "isCompleted",
            caseSensitive: false
        });
    }
    if ('stageViewTwo' in parsedQuery) {
        dynemicFilter.push({
            type: "array",
            value: JSON.stringify([parsedQuery.taskId]),
            key: 'taskId',
            caseSensitive: false
        })
    }
    const dynamicFilterQuery: string = dynemicFilter.length > 0 ? `dynamicFilter=${encodeURIComponent(JSON.stringify(dynemicFilter))}` : '';
    const paginationQuery: string = `page=${pagination.currentPage || 1}&limit=${pagination.limit || 15}`;
    const emailQuery: string = pagination.email ? `email=${encodeURIComponent(pagination.email)}` : '';
    const readQuery: string = typeof pagination.read !== 'undefined' ? `read=${pagination.read}` : '';
    const isMEPQuery: string = parsedQuery.isMEP ? `isMEP=${parsedQuery.isMEP}` : '';
    const isStructuralQuery: string = parsedQuery.isStructural ? `isStructural=${parsedQuery.isStructural}` : '';
    const isFireSprinklerQuery: string = parsedQuery.isFireSprinkler ? `isFireSprinkler=${parsedQuery.isFireSprinkler}` : '';
    const isRunningQuery: string = parsedQuery.isRunning ? `isRunning=${parsedQuery.isRunning}` : '';
    return `?${[dynamicFilterQuery, paginationQuery, emailQuery, readQuery, isMEPQuery, isStructuralQuery, isFireSprinklerQuery, isRunningQuery].filter(Boolean).join('&')}`;
};
export const capitalize = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const removeDuplicates = <T extends TaskWithId>(array: T[]): T[] => {
    const idMap: Record<string, boolean> = {};
    const result: T[] = [];
    array.forEach((obj) => {
        const taskId = obj.taskId._id;
        if (!idMap[taskId]) {
            idMap[taskId] = true;
            result.push(obj);
        }
    });
    return result;
};

export function convertMillisecondsToHoursMinutesSeconds(milliseconds: number) {
    let seconds = Math.floor(milliseconds / 1000);
    const days = Math.floor(seconds / 86400);
    seconds %= 86400;
    const hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    const minutes = Math.floor(seconds / 60);
    seconds %= 60;
    return { days, hours, minutes, seconds };
}
export function msToTime(duration: number) {
    let secondsNum = Math.floor(duration / 1000);
    const hoursNum = Math.floor(secondsNum / 3600);
    secondsNum = secondsNum % 3600;
    const minutesNum = Math.floor(secondsNum / 60);
    secondsNum = secondsNum % 60;
    const hoursStr = (hoursNum < 10) ? "0" + hoursNum : String(hoursNum);
    const minutesStr = (minutesNum < 10) ? "0" + minutesNum : String(minutesNum);
    const secondsStr = (secondsNum < 10) ? "0" + secondsNum : String(secondsNum);
    return { hours: hoursStr, minutes: minutesStr, seconds: secondsStr };
}
export const convertMsToHHMM = (ms: number) => {
    const hours = Math.floor(ms / (1000 * 60 * 60));
    const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};
export function millisecondsToTime(milliseconds: number) {
    let validMs = milliseconds;
    if (validMs < 0) {
        validMs = 0;
    }
    const duration = moment.duration(validMs);
    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();
    const seconds = duration.seconds();
    const formattedTime = moment({ hours, minutes, seconds }).format('HH:mm:ss');
    return formattedTime;
}
export const formatDueDate = (date?: string, fallback = '') => {
    return date ? moment(date.split('T')[0]).format("MMM DD, YYYY") : fallback;
};

export const getTimeDifference = (startTime: number): number => {
    // Current time in milliseconds
    const currentMilliseconds = Date.now();
    // Calculate the difference in milliseconds
    const differenceMilliseconds = currentMilliseconds - startTime;
    // console.log(differenceMilliseconds, "check75", millisecondsToTime(differenceMilliseconds), startTime);
    return differenceMilliseconds
}
export const convertMsToTime = (ms: number) => {
    const hours = Math.floor(ms / (1000 * 60 * 60));
    const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((ms % (1000 * 60)) / 1000);
    return `${hours}h ${minutes}m ${seconds}s`;
};
export const formatMsToHrMin = (ms: number): string => {
    if (!ms) return '0min';
    const totalMinutes = Math.floor(ms / 60000);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    if (hours > 0) {
        return minutes > 0 ? `${hours} hr ${minutes} min` : `${hours} hr`;
    }
    return minutes > 0 ? `${minutes} min` : '0 min';
};
export interface TimeToMsFn {
    (timeStr: string | number | undefined): number;
}
export const timeToMs: TimeToMsFn = (timeStr) => {
    if (!timeStr) return 0;
    const [h, m] = String(timeStr).split(":").map(Number);
    return ((h || 0) * 60 + (m || 0)) * 60 * 1000;
};
export function shouldSkipApi({
    newValue,
    persistedValue,
}: {
    input: HTMLInputElement;
    newValue: string;
    persistedValue: string;
}) {
    const trimmedValue = newValue.trim();
    return trimmedValue === (persistedValue?.trim() ?? '');
}

export const MeetingLinkIcon: React.FC<{ url: string }> = ({ url }) => {
    const [colorMode] = useColorMode();
    const isDarkMode = colorMode === 'dark';
    let href = url.trim();
    if (href.toLowerCase().startsWith('www.')) {
        href = `https://${href}`;
    }
    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: isDarkMode ? 'white' : 'black',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                    color: 'secondary',
                    transform: 'scale(1.2)',
                },
                mx: 1,
            }}
        >
            <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                title={href}
                onClick={(e: React.MouseEvent) => e.stopPropagation()}
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'inherit',
                    cursor: 'pointer',
                    textDecoration: 'none',
                }}
            >
                <FaLink size={15} />
            </a>
        </Box>
    );
};

export const renderMeetingNotes = (text: string) => {
    if (!text) return <span>-</span>;
    // Regex to match URLs (including http, https, www, mailto, frontapp)
    const urlRegex = /((?:https?:\/\/|www\.|mailto:|frontapp:)[^\s]+)/gi;
    const urls = text.match(urlRegex) || [];
    // Clean text of URLs and trim
    const nonUrlText = text.replace(urlRegex, '').trim();
    const hasMeaningfulText = /[a-zA-Z0-9]/i.test(nonUrlText);
    // Case 1: No URLs present -> Display text only
    if (urls.length === 0) {
        return <Box sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{text}</Box>;
    }
    const uniqueUrls = Array.from(new Set(urls));
    // Case 2: Only URL/Link present -> Display link icon
    if (!hasMeaningfulText) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
                {uniqueUrls.map((url, index) => (
                    <MeetingLinkIcon key={index} url={url} />
                ))}
            </Box>
        );
    }
    // Case 3: Both mix present -> Display text - link icon
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
            <Box sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{nonUrlText}</Box>
            <span>-</span>
            {uniqueUrls.map((url, index) => (
                <MeetingLinkIcon key={index} url={url} />
            ))}
        </Box>
    );
};

export const ExpandableText = ({ text, maxLength = 80, fontSize = "13px", sx = {} }: { text: string; maxLength?: number; fontSize?: string; sx?: any }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    if (!text) return <Text sx={{ fontSize, ...sx }}>-</Text>;

    const textStyle = {
        fontSize,
        whiteSpace: "pre-line" as const,
        ...sx
    };

    const linkOverrideStyle = (
        <style>{`
            html[data-theme="light"] td.fixed-column-2.table-cell a,
            html[data-theme="light"] td.fixed-column-2.table-cell a:visited,
            html[data-theme="light"] td.fixed-column-2.table-cell a[href],
            html[data-theme="light"] td.fixed-column-2 a[href],
            html[data-theme="light"] td.table-cell a[href],
            html[data-theme="light"] td a[href],
            body[data-theme="light"] td.fixed-column-2 * a,
            [data-theme="light"] td.fixed-column-2.table-cell a[href],
            html[data-theme="dark"] td.fixed-column-2.table-cell a,
            html[data-theme="dark"] td.fixed-column-2.table-cell a:visited,
            html[data-theme="dark"] td.fixed-column-2.table-cell a[href],
            html[data-theme="dark"] td.fixed-column-2 a[href],
            html[data-theme="dark"] td.table-cell a[href],
            html[data-theme="dark"] td a[href],
            body[data-theme="dark"] td.fixed-column-2 * a,
            [data-theme="dark"] td.fixed-column-2.table-cell a[href],
            td.fixed-column-2.table-cell a[href] {
                color: #6366f1 !important;
                text-decoration: underline !important;
            }
        `}</style>
    );

    const isLong = text.length > maxLength || text.split('\n').length > 3;

    if (!isLong) {
        return (
            <Text sx={textStyle}>
                {linkOverrideStyle}
                {linkifyText(text, "#6366f1")}
            </Text>
        );
    }

    return (
        <Box sx={textStyle}>
            {linkOverrideStyle}
            <Box
                sx={{
                    fontSize,
                    display: isExpanded ? 'block' : '-webkit-box',
                    WebkitLineClamp: isExpanded ? 'unset' : 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    wordBreak: 'break-word'
                }}
            >
                {linkifyText(text, "#6366f1")}
            </Box>
            <Text
                as="div"
                onClick={(e) => {
                    e.stopPropagation();
                    setIsExpanded(!isExpanded);
                }}
                sx={{
                    color: "#7000FF",
                    cursor: "pointer",
                    fontWeight: 500,
                    fontSize: "12px",
                    userSelect: "none",
                    mt: "4px",
                    display: "inline-block"
                }}
            >
                {isExpanded ? "View Less" : "View More"}
            </Text>
        </Box>
    );
};

export interface InlineEditCellProps {
    initialValue: string;
    onSave: (val: string) => void;
    onCancel: () => void;
    borderColor: string;
    colorMode: string;
    textColor: string;
    isLoading?: boolean;
    onChange?: (val: string) => void;
    // the saved text to compare against; initialValue can be an unsaved draft
    originalValue?: string;
}

const INLINE_EDIT_MAX_HEIGHT = 200;

export const InlineEditCell: React.FC<InlineEditCellProps> = ({
    initialValue,
    onSave,
    onCancel,
    borderColor,
    colorMode,
    textColor,
    isLoading,
    onChange,
    originalValue
}) => {
    const [val, setVal] = useState(initialValue);
    const canSave = val.trim() !== "" && val.trim() !== (originalValue ?? initialValue).trim();
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.focus();
            const len = textareaRef.current.value.length;
            textareaRef.current.setSelectionRange(len, len);
        }
    }, []);

    // grow with the text up to INLINE_EDIT_MAX_HEIGHT, then scroll inside the textarea; the border is added because
    // scrollHeight excludes it (border-box), which otherwise leaves a ~2px overflow and a scrollbar that cannot really scroll
    useLayoutEffect(() => {
        const el = textareaRef.current;
        if (!el) return;
        el.style.height = "auto";
        const border = el.offsetHeight - el.clientHeight;
        const fullHeight = el.scrollHeight + border;
        el.style.height = `${Math.min(INLINE_EDIT_MAX_HEIGHT, Math.max(70, fullHeight))}px`;
        el.style.overflowY = fullHeight > INLINE_EDIT_MAX_HEIGHT ? "auto" : "hidden";
    }, [val]);

    return (
        <Flex sx={{ flexDirection: "column", gap: "8px", width: "100%", py: "4px" }}>
            <Textarea
                ref={textareaRef}
                value={val}
                onChange={(e) => {
                    setVal(e.target.value);
                    onChange?.(e.target.value);
                }}
                onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                        e.preventDefault();
                        if (canSave && !isLoading) onSave(val);
                    }
                }}
                autoFocus
                sx={{
                    width: "100%",
                    padding: "8px 10px",
                    borderRadius: "6px",
                    border: `1px solid ${borderColor}`,
                    fontSize: "13px",
                    backgroundColor: colorMode === 'light' ? "#ffffff" : "#0f172a",
                    color: textColor,
                    resize: "vertical",
                    minHeight: "70px",
                    lineHeight: "1.5"
                }}
            />
            <Flex sx={{ gap: "6px", justifyContent: "flex-end" }}>
                <Button
                    onClick={onCancel}
                    sx={{
                        backgroundColor: "transparent",
                        border: `1px solid ${borderColor}`,
                        color: textColor,
                        px: "10px",
                        py: "4px",
                        fontSize: "12px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        whiteSpace: "nowrap"
                    }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={() => onSave(val)}
                    disabled={isLoading || !canSave}
                    sx={{
                        backgroundColor: "#7743DB !important",
                        color: "#ffffff !important",
                        px: "12px",
                        py: "4px",
                        fontSize: "12px",
                        borderRadius: "6px",
                        cursor: canSave ? "pointer" : "not-allowed",
                        opacity: canSave ? 1 : 0.5,
                        whiteSpace: "nowrap",
                        flexShrink: 0
                    }}
                >
                    {isLoading ? <Spinner size={12} sx={{ color: "#ffffff !important" }} /> : "Save"}
                </Button>
            </Flex>
        </Flex>
    );
}
const triggerIframeDownload = (urlStr: string) => {
    if (!urlStr) return;
    let fullUrl = urlStr;
    const cdnDomain = bucketUrl || process.env.REACT_APP_CDN_URL || 'https://preprod-pec-media-v2.priority-proengc.com/';
    if (!urlStr.startsWith('http://') && !urlStr.startsWith('https://')) {
        const cleanBucket = cdnDomain.replace(/\/+$/, '');
        const cleanUrl = urlStr.startsWith('/') ? urlStr : `/${urlStr}`;
        fullUrl = `${cleanBucket}${cleanUrl}`;
    }
    const link = document.createElement('a');
    link.href = fullUrl;
    link.target = '_blank';
    link.rel = 'noreferrer';
    const filename = fullUrl.split('/').pop() || 'download';
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const downloadAttachments = async (urlsToDownload: string[]) => {
    if (!urlsToDownload || urlsToDownload.length === 0) return;

    for (const url of urlsToDownload) {
        if (url) {
            triggerIframeDownload(url);
        }
    }
};
export const getPriorityStyles = (priorityVal: string) => {
    const val = (priorityVal || '').toLowerCase();
    let color = '#ea580c';
    let bg = '#fff7ed';
    let border = '#fed7aa';

    if (val === 'high') {
        color = '#dc2626';
        bg = '#fef2f2';
        border = '#fca5a5';
    } else if (val === 'low') {
        color = '#16a34a';
        bg = '#f0fdf4';
        border = '#bbf7d0';
    }

    return {
        control: (base: any) => ({
            ...base,
            backgroundColor: bg,
            borderColor: border,
            borderRadius: '8px',
            minHeight: '32px',
            boxShadow: 'none',
            '&:hover': {
                borderColor: border,
            },
        }),
        singleValue: (base: any) => ({
            ...base,
            color: `${color} !important`,
            fontWeight: 600,
            fontSize: '13px',
        }),
        dropdownIndicator: (base: any) => ({
            ...base,
            color: color,
            padding: '2px 6px',
            '&:hover': {
                color: color,
            },
        }),
        indicatorSeparator: () => ({
            display: 'none',
        }),
        option: (base: any, state: any) => {
            const optVal = (state.data?.value || state.data?.label || '').toLowerCase();
            let optColor = '#ea580c';
            let optBg = 'transparent';
            if (optVal === 'high') {
                optColor = '#dc2626';
                optBg = state.isSelected || state.isFocused ? '#fef2f2' : 'transparent';
            } else if (optVal === 'low') {
                optColor = '#16a34a';
                optBg = state.isSelected || state.isFocused ? '#f0fdf4' : 'transparent';
            } else {
                optBg = state.isSelected || state.isFocused ? '#fff7ed' : 'transparent';
            }
            return {
                ...base,
                color: optColor,
                backgroundColor: optBg,
                fontWeight: 600,
                fontSize: '13px',
                cursor: 'pointer',
                '&:active': {
                    backgroundColor: optBg,
                    color: optColor,
                },
            };
        },
    };
};

export const formatDataKey = (key: string): string => {
    switch (key?.trim()?.toLowerCase()) {
        case 'revision':
            return 'Revisions';

        case 'plan check':
            return 'Plan Check Tasks';

        case 'need info':
            return 'Need Info Tasks';

        case 'delivery notes':
            return 'Delivery Notes';

        case 'blocked by trade':
            return 'Blocked By Trade Tasks';

        case 'time spent':
            return ' Time Spent';

        case 'subtask':
            return 'Associated Subtasks';

        default:
            return key;
    }
};

export const isReqTimeEstimateOrIPRToDo = (status?: string): boolean => {
    if (!status) return false;
    const cleanStatus = status.trim().toLowerCase();
    return cleanStatus === 'req time estimate' || cleanStatus === 'ipr todo' || cleanStatus === 'ipr todo';
};

export const checkDeletionPermission = (
    item: DeletionItemStage | DeletionItemTask | null | undefined,
    userRoles: DeletionUserRoleInput[],
    itemType: 'stage' | 'task' = 'task'
): DeletionPermissionResult => {
    const rolesList = Array.isArray(userRoles)
        ? userRoles.map((r) => (typeof r === 'string' ? r : r?.RoleName || '')?.trim()?.toLowerCase())
        : [];

    const isSuperAdmin = rolesList.some((r: string) => r === 'super admin');
    const isProjectManager = rolesList.some((r: string) => r === 'project manager');

    const dataKeysSet = new Set<string>();

    const inspectSingleTask = (task: DeletionItemTask | null | undefined) => {
        if (!task) return;

        // 1. Time Spend Check
        const timeSpend = Number(task?.timeSpend || task?.timeSpent || task?.totalSpentTime || task?.spentTime || 0);
        const taskEstimateList = task?.taskEstimateList || task?.payload?.taskEstimateList || [];
        const hasEstimateSpent = Array.isArray(taskEstimateList) && taskEstimateList.some((t) => Number(t?.spentTime || t?.timeSpend || t?.timeSpent || 0) > 0);
        const taskFields = task?.taskFields || task?.payload?.taskFields || [];
        const hasTaskFieldsSpent = Array.isArray(taskFields) && taskFields.some((f) => Number(f?.timeSpend || 0) > 0 || (f?.fieldName === 'Time Spend' && Number(f?.value || 0) > 0));

        if (timeSpend > 0 || hasEstimateSpent || hasTaskFieldsSpent) {
            dataKeysSet.add('time spent');
        }

        // 2. Highlighters & Actions Check
        const highlighters = task?.highlighters || task?.payload?.highlighters || [];
        const actions = task?.actions || task?.payload?.actions || [];

        const checkAction = (targetName: string) => {
            const lowerTarget = targetName.toLowerCase();
            const inHighlighters = Array.isArray(highlighters) && highlighters.some((h) => {
                const name = typeof h === 'string' ? h : (h?.name || h?.label || h?.title);
                return name && String(name).trim().toLowerCase().includes(lowerTarget);
            });
            const inActions = Array.isArray(actions) && actions.some((a) => {
                const name = typeof a === 'string' ? a : (a?.name || a?.actionType || a?.label || a?.payload?.name);
                return name && String(name).trim().toLowerCase().includes(lowerTarget);
            });
            return inHighlighters || inActions;
        };

        if (checkAction('revision') || checkAction('rev')) dataKeysSet.add('revisions');
        if (checkAction('plan check') || checkAction('pc')) dataKeysSet.add('plan check');
        if (checkAction('need info') || checkAction('ni')) dataKeysSet.add('need info');
        if (checkAction('delivery notes') || checkAction('delivery')) dataKeysSet.add('delivery notes');
        if (checkAction('blocked by trade') || checkAction('bt')) dataKeysSet.add('blocked by trade');
        if (checkAction('todo per review')) dataKeysSet.add('todo per review');

        // 3. Subtasks Check
        const subtasks = task?.subtasks || [];
        if (Array.isArray(subtasks) && subtasks.length > 0) {
            dataKeysSet.add('subtask');
        }
    };

    if (itemType === 'stage') {
        inspectSingleTask(item);
        const stageItem = item as DeletionItemStage;
        const taskList = stageItem?.TaskData || stageItem?.tasksData || stageItem?.tasksNameList || [];
        if (Array.isArray(taskList)) {
            taskList.forEach((t) => inspectSingleTask(t));
        }
    } else {
        inspectSingleTask(item);
    }

    const dataKeys = Array.from(dataKeysSet);
    const hasProgress = dataKeys.length > 0;
    const itemStatus = item?.status || item?.stageStatus || item?.lastStatus;
    const isAllowedStatus = isReqTimeEstimateOrIPRToDo(itemStatus);

    if (isSuperAdmin) {
        if (hasProgress) {
            const formattedLabels = dataKeys.map(formatDataKey).join(', ');
            return {
                allowed: true,
                confirmationRequired: true,
                dataKeys,
                message: `This ${itemType} has already ${formattedLabels}. Are you sure you want to delete it?`
            };
        }
        return {
            allowed: true,
            confirmationRequired: true,
            dataKeys: [],
            message: `Are you sure you want to delete this ${itemType}?`
        };
    }

    if (isProjectManager) {
        if (isAllowedStatus && !hasProgress) {
            return {
                allowed: true,
                confirmationRequired: true,
                dataKeys: [],
                message: `Are you sure you want to delete this ${itemType}?`
            };
        }
        return {
            allowed: false,
            confirmationRequired: false,
            dataKeys: [],
            message: `To delete this ${itemType}, please contact to Super Admin.`
        };
    }

    return {
        allowed: false,
        confirmationRequired: false,
        dataKeys: [],
        message: `To delete this ${itemType}, please contact to Super Admin.`
    };
};

export const checkRevisionDeletionPermission = (
    item: DeletionItemTask | null | undefined,
    userRoles: DeletionUserRoleInput[],
    itemStatus?: string
): DeletionPermissionResult => {
    const rolesList = Array.isArray(userRoles)
        ? userRoles.map((r) => (typeof r === 'string' ? r : r?.RoleName || '')?.trim()?.toLowerCase())
        : [];

    const isSuperAdmin = rolesList.some((r: string) => r === 'super admin');
    const isProjectManager = rolesList.some((r: string) => r === 'project manager');

    const payload = item?.payload || item || {};
    const rawEstimateList = payload?.taskEstimateList || item?.taskEstimateList;
    const taskEstimateList = Array.isArray(rawEstimateList) ? rawEstimateList : [];
    const hasEstimateSpent = taskEstimateList.some((t) => Number(t?.spentTime || t?.timeSpend || t?.timeSpent || 0) > 0);
    const directSpentTime = Number(item?.timeSpend || item?.timeSpent || item?.spentTime || payload?.timeSpend || payload?.timeSpent || payload?.spentTime || 0);
    const hasTimeSpent = hasEstimateSpent || directSpentTime > 0;

    const currentStatus = itemStatus || item?.status || payload?.status;
    const isAllowedStatus = isReqTimeEstimateOrIPRToDo(currentStatus);

    const defaultTitle = payload?.name || item?.name || "this action";

    if (isSuperAdmin) {
        if (hasTimeSpent) {
            return {
                allowed: true,
                confirmationRequired: true,
                dataKeys: ['time spent'],
                message: `This revision has already Logged Time Spent. Are you sure you want to delete it?`
            };
        }
        return {
            allowed: true,
            confirmationRequired: true,
            dataKeys: [],
            message: `Are you sure you want to delete ${defaultTitle} in this action?`
        };
    }

    if (isProjectManager) {
        if (isAllowedStatus && !hasTimeSpent) {
            return {
                allowed: true,
                confirmationRequired: true,
                dataKeys: [],
                message: `Are you sure you want to delete ${defaultTitle} in this action?`
            };
        }
        return {
            allowed: false,
            confirmationRequired: false,
            dataKeys: [],
            message: `To delete this item, please contact to Super Admin.`
        };
    }

    return {
        allowed: false,
        confirmationRequired: false,
        dataKeys: [],
        message: `To delete this item, please contact to Super Admin.`
    };
};

export const extractGdLinks = (item: DeliveryData): string[] => {
    const gdLinks = item?.payload?.gdLinks;
    if (!Array.isArray(gdLinks)) return [];
    return gdLinks
        .map((g: unknown) => (typeof g === 'string' ? g : (g && typeof g === 'object' ? (g as Record<string, unknown>).link || '' : '')) as string)
        .map(s => String(s || '').trim())
        .filter(Boolean);
};

export const extractFrontAppLinks = (item: DeliveryData): string[] => {
    const links = item?.payload?.frontAppLinks;
    const frontAppLinks = Array.isArray(links)
        ? links
            .map((l: unknown) => (typeof l === 'string' ? l : (l && typeof l === 'object' ? (l as Record<string, unknown>).link || '' : '')) as string)
            .map(s => String(s || '').trim())
            .filter(Boolean)
        : [];
    if (frontAppLinks.length) return frontAppLinks;
    const emailLink: unknown = item?.payload?.emailLink;
    const emailTexts = (Array.isArray(emailLink) ? emailLink : [emailLink]).filter((e): e is string => typeof e === 'string');
    return emailTexts
        .flatMap(text => text.match(/https?:\/\/[^\s,)]+/g) || [])
        .filter(url => url.startsWith('https://app.frontapp.com'));
};

export const extractPdfLinks = (item: DeliveryData): string[] => {
    const docs = item?.payload?.uploadedDocuments;
    if (!Array.isArray(docs)) return [];
    return docs
        .map((p: unknown) => (typeof p === 'string' ? p : (p && typeof p === 'object' ? (p as Record<string, unknown>).link || '' : '')) as string)
        .map(s => String(s || '').trim())
        .filter(Boolean);
};

export const extractSheetIndexFromDescriptions = (descriptions: DescriptionPayload[]): SheetIndexItem[] => {
    if (!Array.isArray(descriptions)) return [];
    const items: SheetIndexItem[] = [];

    descriptions.forEach((desc: DescriptionPayload) => {
        const sheetNo = desc.sheetNo || '';
        if (sheetNo) {
            items.push({
                sheetNo,
                sheetTitle: desc.sheetTitle || desc.name || '',
                discipline: desc.discipline || '',
                notes: desc.status || (desc.isUpdated ? 'Updated' : 'Unchanged'),
                isUpdated: !!desc.isUpdated,
            });
        }
    });

    return items;
};

export const extractTaskIdFromDesc = (desc: DescriptionPayload): string => {
    const rawT = desc?.taskId;
    if (rawT) {
        if (typeof rawT === 'object' && rawT !== null) {
            const objId = String((rawT as Record<string, unknown>)._id || (rawT as Record<string, unknown>).id || '');
            if (objId) return objId;
        }
        if (typeof rawT === 'string' && rawT.trim()) return rawT.trim();
    }

    if (typeof desc?.planCheckId === 'object' && desc?.planCheckId !== null) {
        const pcTasks = desc.planCheckId.payload?.taskId || desc.planCheckId.taskId;
        if (Array.isArray(pcTasks) && pcTasks.length > 0) {
            const first = pcTasks[0];
            if (typeof first === 'object' && first !== null) {
                const objId = String((first as Record<string, unknown>)._id || (first as Record<string, unknown>).id || '');
                if (objId) return objId;
            }
            if (typeof first === 'string' && first.trim()) return first.trim();
        } else if (typeof pcTasks === 'string' && pcTasks.trim()) {
            return pcTasks.trim();
        }
    }

    if (typeof desc?.revisionId === 'object' && desc?.revisionId !== null) {
        const revTasks = desc.revisionId.payload?.taskId || desc.revisionId.taskId;
        if (Array.isArray(revTasks) && revTasks.length > 0) {
            const first = revTasks[0];
            if (typeof first === 'object' && first !== null) {
                const objId = String((first as Record<string, unknown>)._id || (first as Record<string, unknown>).id || '');
                if (objId) return objId;
            }
            if (typeof first === 'string' && first.trim()) return first.trim();
        } else if (typeof revTasks === 'string' && revTasks.trim()) {
            return revTasks.trim();
        }
    }

    return '';
};

export interface TradeInfo {
    code: string;
    name: string;
    isStandard: boolean;
}

export const getTradeInfo = (input: string, allowInitials = false): TradeInfo => {
    if (!input) {
        return { code: '', name: '', isStandard: false };
    }

    const isHex = /^[0-9a-fA-F]{24}$/.test(input.trim());
    const clean = input.replace(/\s*\([^)]*\)/g, '').trim();
    const condensed = clean.replace(/[\s_-]+/g, '').toUpperCase();

    if ((condensed.includes('STRUCT') && condensed.includes('DESIGN')) || condensed === 'SD') {
        return { code: 'SD', name: 'Structural Design', isStandard: true };
    }
    if (condensed.includes('MECH') || condensed === 'M') {
        return { code: 'M', name: 'Mechanical', isStandard: true };
    }
    if (condensed.includes('ELEC') || condensed === 'E') {
        return { code: 'E', name: 'Electrical', isStandard: true };
    }
    if (condensed.includes('PLUMB') || condensed === 'P') {
        return { code: 'P', name: 'Plumbing', isStandard: true };
    }
    if (condensed.includes('STRUCT') || condensed === 'S') {
        return { code: 'S', name: 'Structural', isStandard: true };
    }

    if (allowInitials && !isHex) {
        const words = clean.split(/[\s_-]+/).filter(Boolean);
        const code = words.length > 1
            ? words.slice(0, 2).map((w) => w[0].toUpperCase()).join('')
            : clean.charAt(0).toUpperCase();
        return { code, name: clean, isStandard: false };
    }
    return { code: '', name: clean, isStandard: false };
};

export const normalizeTradeName = (name: string): string => getTradeInfo(name).name;

export const getHardcodedTradeCode = (text: string): string => getTradeInfo(text, false).code;

export const getTradeCode = (name: string): string => getTradeInfo(name, true).code;

export const getTabStyle = (
    tabName: string,
    isActive: boolean,
    isDark: boolean,
    defaultAccent: string,
    tradesList?: TradeItem[],
    allTasks?: Array<Record<string, unknown>>
) => {
    const code = getTradeCode(tabName);
    let dynamicColor = '';

    if (tradesList && tradesList.length > 0) {
        const matchedTrade = tradesList.find(
            t => t.name === tabName || t.code === code || normalizeTradeName(t.name) === tabName
        );
        if (
            matchedTrade?.color &&
            matchedTrade.color !== '#000000' &&
            matchedTrade.color !== '#000' &&
            matchedTrade.color !== '#BB86FC' &&
            matchedTrade.color !== '#7743DB'
        ) {
            dynamicColor = matchedTrade.color;
        }
    }

    if (!dynamicColor && allTasks && allTasks.length > 0) {
        const normalized = normalizeTradeName(tabName).toLowerCase();
        const matchedTask = allTasks.find((t) => {
            const tName = String(t?.name || t?.taskName || '').toLowerCase().trim();
            const tCode = getTradeCode(tName);
            return (
                tName === tabName.toLowerCase().trim() ||
                (normalized !== '' && tName === normalized) ||
                (code !== '' && tCode === code) ||
                (normalized !== '' && tName.includes(normalized)) ||
                (normalized !== '' && normalized.includes(tName))
            );
        });

        const taskColor = String(matchedTask?.color || '');
        if (taskColor && taskColor !== '#000000' && taskColor !== '#000') {
            dynamicColor = taskColor;
        }
    }

    if (dynamicColor) {
        return {
            color: dynamicColor,
            bg: isActive ? `${dynamicColor}20` : 'transparent',
            border: isActive ? dynamicColor : (isDark ? `${dynamicColor}40` : `${dynamicColor}60`),
        };
    }

    return {
        color: isActive ? defaultAccent : (isDark ? '#94a3b8' : '#64748b'),
        bg: isActive ? (isDark ? '#2e3a50' : '#f0eafd') : 'transparent',
        border: isActive ? defaultAccent : (isDark ? '#334758' : '#e2e8f0'),
    };
};

export const getPlanCheckRevName = (desc: DescriptionPayload, defaultStage: string): string => {
    if (typeof desc?.planCheckId === 'object' && desc?.planCheckId) {
        const pcName = desc.planCheckId.payload?.name || desc.planCheckId.name;
        if (pcName) return pcName;
    }
    if (typeof desc?.revisionId === 'object' && desc?.revisionId) {
        const revName = desc.revisionId.payload?.name || desc.revisionId.name;
        if (revName) return revName;
    }
    if (typeof desc?.stageId === 'object' && desc?.stageId) {
        const stName = desc.stageId.temporaryName || desc.stageId.name;
        if (stName) return stName;
    }
    return desc?.stageRev || defaultStage;
};

export const resolveTradeDetails = (desc: DescriptionPayload, stageTasks: Record<string, unknown>[], isDark: boolean) => {
    const taskIdStr = extractTaskIdFromDesc(desc);
    const taskObj = typeof desc?.taskId === 'object' && desc?.taskId ? desc.taskId : null;
    const matchedTask = taskIdStr && Array.isArray(stageTasks)
        ? stageTasks.find((t) => {
            const sId = String(t?._id || t?.id || '');
            const stageDataId = String(t?.stageDataId || '');
            const tId = typeof t?.taskId === 'object' && t?.taskId !== null
                ? String((t.taskId as Record<string, unknown>)._id || (t.taskId as Record<string, unknown>).id || '')
                : (t?.taskId ? String(t.taskId) : '');
            return sId === taskIdStr || (stageDataId !== '' && stageDataId === taskIdStr) || (tId !== '' && tId === taskIdStr);
        })
        : null;

    const explicitTrade = String(taskObj?.name || desc?.taskInfo?.name || matchedTask?.name || desc?.trade || '');
    let tradeCode = getTradeCode(explicitTrade);
    if (!tradeCode) {
        const noteText = String(desc?.name || desc?.notes || '');
        tradeCode = getHardcodedTradeCode(noteText);
    }

    const codeMatchedTask = !matchedTask && tradeCode && Array.isArray(stageTasks)
        ? stageTasks.find((t) => {
            const tName = String(t?.name || t?.taskName || '');
            return getTradeCode(tName) === tradeCode;
        })
        : null;

    const finalTask = matchedTask || codeMatchedTask;

    const tradeName = String(taskObj?.name || desc?.taskInfo?.name || finalTask?.name || desc?.trade || '').replace(/\s*\(.*?\)/g, '').trim() || tradeCode;
    const color = String(taskObj?.color || (desc as { taskInfo?: { color?: string } })?.taskInfo?.color || finalTask?.color || (isDark ? '#BB86FC' : '#7743DB'));

    return { taskIdStr, tradeName, tradeCode, color };
};

export const getResolvedTrade = (d: any, stageTasks: Record<string, unknown>[], tradesList?: TradeItem[]): string => {
    const rawTrade = d.trade || '';
    const isRawHex = /^[0-9a-fA-F]{24}$/.test(rawTrade.trim());

    if (rawTrade && !isRawHex) {
        return normalizeTradeName(rawTrade);
    }

    const searchId = d.taskId || rawTrade;
    if (searchId && stageTasks.length > 0) {
        const found = stageTasks.find((t: Record<string, unknown>) => {
            const stageTaskId = String(t?._id || t?.id || '');
            const stageDataId = String(t?.stageDataId || '');
            const actualTaskId = typeof t?.taskId === 'object' && t?.taskId !== null
                ? String((t.taskId as Record<string, unknown>)._id || (t.taskId as Record<string, unknown>).id || '')
                : (t?.taskId ? String(t.taskId) : '');
            return searchId === stageTaskId || (stageDataId !== '' && searchId === stageDataId) || searchId === actualTaskId;
        });
        if (found?.name || found?.taskName) {
            return normalizeTradeName(String(found.name || found.taskName));
        }
    }

    const textToSearch = `${d.notes || ''} ${d.discipline || ''} ${d.trade || ''}`;
    const textTrade = getTradeInfo(textToSearch);
    if (textTrade.isStandard) return textTrade.name;

    if (tradesList && tradesList.length > 0) {
        const validTrade = tradesList.find((t) => t.name && !/^[0-9a-fA-F]{24}$/.test(t.name));
        if (validTrade?.name) return normalizeTradeName(validTrade.name);
    }

    return rawTrade && !isRawHex ? normalizeTradeName(rawTrade) : 'General';
};

export const resolveChildTrades = (
    subDescRaw: DescriptionPayload[],
    parentTrades: TradeItem[],
    stageTasks: Record<string, unknown>[],
    isDark: boolean
): TradeItem[] => {
    const noteTaskIds = new Set<string>();
    const noteTradeCodes = new Set<string>();

    subDescRaw.forEach((desc) => {
        const tIdStr = extractTaskIdFromDesc(desc);
        if (tIdStr) noteTaskIds.add(tIdStr);

        const explicitTrade = (typeof desc?.taskId === 'object' && desc?.taskId ? desc.taskId.name : '') || desc?.taskInfo?.name || desc?.trade || '';
        if (explicitTrade) {
            const code = getTradeCode(explicitTrade);
            if (code) noteTradeCodes.add(code);
        } else {
            const noteText = desc?.name || desc?.notes || '';
            const code = getHardcodedTradeCode(noteText);
            if (code) noteTradeCodes.add(code);
        }
    });

    let childTradesRaw: TradeItem[] = [];
    if (stageTasks.length > 0 && (noteTaskIds.size > 0 || noteTradeCodes.size > 0)) {
        childTradesRaw = stageTasks
            .filter((t) => {
                const stageTaskId = String(t?._id || t?.id || '');
                const stageDataId = String(t?.stageDataId || '');
                const actualTaskId = typeof t?.taskId === 'object' && t?.taskId !== null
                    ? String((t.taskId as Record<string, unknown>)._id || (t.taskId as Record<string, unknown>).id || '')
                    : (t?.taskId ? String(t.taskId) : '');
                const tName = String(t?.name || t?.taskName || '');
                const tCode = getTradeCode(tName);

                return noteTaskIds.has(stageTaskId) || (stageDataId !== '' && noteTaskIds.has(stageDataId)) || (actualTaskId && noteTaskIds.has(actualTaskId)) || (tCode && noteTradeCodes.has(tCode));
            })
            .map((t) => {
                const tName = String(t?.name || t?.taskName || '');
                return {
                    name: tName,
                    color: String(t?.color || (isDark ? '#BB86FC' : '#7743DB')),
                    code: getTradeCode(tName),
                };
            });
    }

    if (noteTradeCodes.size > 0) {
        const existingCodes = new Set(childTradesRaw.map((t) => t.code || getTradeCode(t.name)));
        noteTradeCodes.forEach((code) => {
            if (!existingCodes.has(code)) {
                childTradesRaw.push({
                    name: normalizeTradeName(code) || code,
                    color: isDark ? '#BB86FC' : '#7743DB',
                    code,
                });
            }
        });
    }

    if (childTradesRaw.length === 0) {
        childTradesRaw = parentTrades;
    }

    const childTrades: TradeItem[] = [];
    const seenChildCodes = new Set<string>();
    childTradesRaw.forEach((t) => {
        const c = t.code || getTradeCode(t.name);
        if (c && !seenChildCodes.has(c)) {
            seenChildCodes.add(c);
            childTrades.push(t);
        }
    });

    return childTrades;
};

/**
 * Adds the given number of business days (Mon-Fri, skipping Saturday and Sunday)
 * to a date.
 *
 * @param dateValue - The start date (YYYY-MM-DD string or any moment input).
 * @param days - Number of business days to add.
 * @returns The resulting date as YYYY-MM-DD, or '' if the input is empty/invalid.
 */
export const addBusinessDays = (dateValue: moment.MomentInput, days: number): string => {
    if (!dateValue) return '';

    const date = moment(dateValue);
    if (!date.isValid()) return '';

    let added = 0;
    while (added < days) {
        date.add(1, 'day');
        const day = date.day();
        if (day !== 0 && day !== 6) added++;
    }

    return date.format('YYYY-MM-DD');
};
